import { render, staticRenderFns } from "./user-expressinfo.vue?vue&type=template&id=d33fe252"
import script from "./user-expressinfo.vue?vue&type=script&lang=ts"
export * from "./user-expressinfo.vue?vue&type=script&lang=ts"
import style0 from "./user-expressinfo.vue?vue&type=style&index=0&id=d33fe252&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports